import { ApiError, createApiClient } from "@custos/api-client";
import { QueryClient } from "@tanstack/react-query";
import { useAuth } from "./auth";

/**
 * One API client for the whole app. The refresh token is an httpOnly cookie (decision D18), so the
 * page never sees it; the short-lived access token stays in this client's memory.
 */
export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL || "/api",
  transport: "cookie",
  onSessionExpired: () => useAuth.getState().sessionExpired(),
});

api.onAuthChange((loggedIn) => {
  if (loggedIn) useAuth.getState().setAuthenticated();
  else useAuth.getState().setAnonymous();
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // Retry network hiccups and server errors, never "you're not allowed" answers.
      retry: (count, error) =>
        count < 2 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
      refetchOnWindowFocus: true,
    },
  },
});
